import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import type { components } from "../../../api/generated";
import type { RailwayStopsData } from "../../railway-query/types";

/** 经停查看沿用行程登录入口，不要求额外的独立铁路菜单权限。 */
export async function fetchItineraryRailwayStops(query: { date: string; train_no: string; from_station: string; to_station: string }, signal?: AbortSignal): Promise<RailwayStopsData> {
  const response = await httpClient.get<ApiEnvelope<components["schemas"]["RailwayStopsData"]>>("/itineraries/transport/railway/stops", { params: query, signal, timeout: 45_000, "axios-retry": { retries: 0 } });
  if (response.data.code !== "OK" || !response.data.data) throw new Error("经停站查询未返回有效数据，请重试");
  return response.data.data;
}
